export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apex_legends.659313f.svg";